"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleSidebar = exports.closeSidebar = exports.openSidebar = void 0;
var redux_saga_routines_1 = require("redux-saga-routines");
// creating routine
exports.openSidebar = (0, redux_saga_routines_1.createRoutine)('sidebar/OPEN');
exports.closeSidebar = (0, redux_saga_routines_1.createRoutine)('sidebar/CLOSE');
exports.toggleSidebar = (0, redux_saga_routines_1.createRoutine)('sidebar/TOGGLE');
